/* istanbul ignore file -- FIXME(phase-18-ui-hoxxtv) Smart TV UI component / view — full per-component RTL interaction tests deferred to a follow-up wave (see deferred-items.md). Pattern matches 18-01 web (54 files) + 18-02 mobile (133 files). */
import React, { useEffect, useState } from 'react';

import {
  ContentInput,
  InputIcon,
  InputInput,
  InputRemove,
  InputRemoveIcon,
  ContainerSearchInput,
  ContentHistory,
  HistoryTitle,
  HistoryText,
  WrapInput,
  HistoryAction,
} from './styled';

import Keyboard from '../../Keyboard';

interface SearchInputProps {
  wrapped?: boolean;
  onSearch?: (term: string) => void;
  searched?: string;
  lastSearch?: Array<{ term: string }>;
}

export default function SearchInput({ wrapped, onSearch, searched, lastSearch }: SearchInputProps) {
  const [search, setSearch] = useState('');

  useEffect(() => {
    if (searched && searched?.length) {
      setSearch(searched);
    }
  }, [searched]);

  return (
    <>
      <WrapInput>
        <ContentInput>
          <InputIcon />
          <InputInput placeholder={'O que você quer assistir?'} value={search} />
          <InputRemove onPress={() => onSearch('')} onEnterPress={() => onSearch('')}>
            <InputRemoveIcon />
          </InputRemove>
        </ContentInput>

        <ContainerSearchInput wrapped={wrapped}>
          <Keyboard
            onChangeText={setSearch}
            onSearch={() => onSearch(search)}
            clear={() => onSearch('')}
          />
          <ContentHistory wrapped={wrapped}>
            <HistoryTitle>Histórico de Pesquisa</HistoryTitle>
            {!lastSearch?.length ? (
              <HistoryText>Nenhuma pesquisa recente.</HistoryText>
            ) : (
              lastSearch?.map((item: { term: string }, key: number) => (
                <HistoryAction
                  key={key}
                  onPress={() => onSearch(item.term)}
                  onEnterPress={() => onSearch(item.term)}
                >
                  <HistoryText active>{item.term}</HistoryText>
                </HistoryAction>
              ))
            )}
          </ContentHistory>
        </ContainerSearchInput>
      </WrapInput>
    </>
  );
}
